import { Notify } from 'vant';
import router from '@/router';
import cacheKit from '@/utils/cacheKit';

export default {
    socket: {},
    //监听器
    listeners:[],
    //是否在聊天中:
    isInChatting:false,
    getIsInChatting(){
        return this.isInChatting;
    },
    setIsInChatting(isInChatting1){
        this.isInChatting=isInChatting1;
    },
    //删除监听器
    removeListener(listener){
        let listeners = this.listeners;
        listeners.forEach(function(element,index,arr) {
            if(element==listener){
                listeners.splice(index,1);
            }
        });
    },
    //定时器
    timer:null,
    /**
     * 开始socket 
     */
    startSocket(url) {
        if(typeof(WebSocket) == "undefined") {
            console.log("您的浏览器不支持WebSocket");  
        }else{
            
            if(!this.timer){
                //定时任务保持连接
                var that = this;
                this.timer = setInterval(function(){
                    // console.info("date",new Date());
                    that.startSocket(url);
                },3000);
            }
           
            let userInfo = cacheKit.get("userInfo");
            
            if(!userInfo||!userInfo.id){
                return;
            }

            var readyState  = this.socket.readyState;
            
            if(readyState==1){
                //已连接
                return;
            }

            console.log("您的浏览器支持WebSocket");  
                //实现化WebSocket对象，指定要连接的服务器地址与端口  建立连接  
                //等同于socket = new WebSocket("ws://localhost:8083/checkcentersys/websocket/20"); 
              var socketUrl = (url).replace("http","ws");
              console.info("socketUrl=",socketUrl+userInfo.id); 
              var socket = new WebSocket(socketUrl+userInfo.id);  
              this.socket = socket;
  
                //打开事件  
                socket.onopen = function() {  
                    console.log("Socket 已打开");  
                    //socket.send("这是来自客户端的消息" + location.href + new Date());  
                };  
                //获得消息事件 
                
                var listeners = this.listeners;
                let that = this;
                socket.onmessage = function(msg) {  
                    console.log("msg.data",msg.data);  
                    let message = JSON.parse(msg.data);
                    for(let i=0;i<listeners.length;i++){
                        let listener = listeners[i];
                        if(listener){
                            //执行监听器
                            try{
                                console.info("执行监听器")
                                listener(message); 
                            }catch(e){
                                console.error(e);
                            }
                        }
                    }

                    //发现消息进入    开始处理前端触发逻辑
                    console.info("isInChatting=",that.isInChatting);
                    if(!that.isInChatting){
                        let str = message.myName+": "+message.content;
                        Notify({
                            message: str,
                            duration: 3000,
                            background: 'rgba(0,0,0,0.5)',
                            onClick:()=>{
                                console.info("点击");
                                if(message.userId&&message.userId>0){
                                    router.push('/home/mainPage/chatting/'+message.userId);
                                }
                            }
                          });
                    }
                    
                };  
                //关闭事件  
                socket.onclose = function() {  
                    console.log("Socket已关闭");  
                };  
                //发生了错误事件  
                socket.onerror = function() {  
                    // Notify("网络错误");  
                    console.error("socket error");
                    //此时可以尝试刷新页面
                }  
          }
    },
    sendMsg(message){

    },
}



// WEBPACK FOOTER //
// ./src/utils/messageSocket.js